var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcNavSearch = function SvgIcNavSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0432173,21.7213998 L19.532553,17.2186663 C22.9921725,12.7718603 22.3973893,6.40139003 18.1743823,2.67187759 C13.9513753,-1.05763484 7.55624461,-0.860247151 3.57128221,3.1226068 C-0.413680187,7.10546076 -0.614452414,13.5004861 3.11282451,17.7254663 C6.84010144,21.9504465 13.2102561,22.5486012 17.6588924,19.0913355 L22.1596432,23.6069566 C22.4067354,23.8570651 22.7432493,23.9984883 23.0948266,23.9999883 C23.446404,24.0014646 23.784103,23.8628952 24.0333037,23.6148874 L24.0432173,23.6069566 C24.295901,23.3593524 24.4391134,23.0210073 24.4409937,22.6672369 C24.4428373,22.3134666 24.3031943,21.9736328 24.0531308,21.7233825 L24.0432173,21.716443 L24.0432173,21.7213998 Z M3.1751988,10.7094307 C3.17479789,7.48557725 5.1164918,4.5789422 8.09482898,3.34494903 C11.0731662,2.11095586 14.5015797,2.79263265 16.7813301,5.07209955 C19.0610806,7.35156645 19.7431838,10.7798952 18.5095611,13.7583858 C17.2759384,16.7368765 14.3695449,18.6789319 11.1456914,18.6789319 C6.74409704,18.6789319 3.17574633,15.1110251 3.1751988,10.7094307 Z",
    id: "ic_search",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcNavSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_nav_search.e9209ce8.svg";
export { ForwardRef as ReactComponent };